export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-32 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image Collage */}
          <div className="w-full lg:w-2/5 relative">
            <div className="grid grid-cols-2 gap-3 h-[480px] md:h-[540px]">
              {/* Main tall image */}
              <div className="row-span-2 rounded-2xl overflow-hidden w-full h-full">
                <img
                  src="https://public.readdy.ai/ai/img_res/91f8ddab5fbc3990694f5d129f73110b.jpg"
                  alt="Typical Chicago brick bungalow home by Butler Frelix"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Top right image */}
              <div className="rounded-2xl overflow-hidden w-full h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Chicago%20two%20flat%20greystone%20building%20exterior%20classic%20limestone%20facade%20bay%20windows%20ornate%20details%20tree%20lined%20street%20urban%20Chicago%20neighborhood%20bright%20daylight%20photography&width=500&height=340&seq=chi_home2&orientation=landscape"
                  alt="Chicago greystone two-flat home"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Bottom right image */}
              <div className="rounded-2xl overflow-hidden w-full h-full">
                <img
                  src="https://readdy.ai/api/search-image?query=renovated%20Chicago%20brick%20row%20house%20newly%20constructed%20addition%20modern%20craftsman%20front%20door%20black%20window%20frames%20updated%20landscaping%20urban%20Chicago%20residential%20block%20afternoon%20sunlight&width=500&height=340&seq=chi_home3&orientation=landscape"
                  alt="Renovated Chicago row house"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

          </div>

          {/* Content */}
          <div className="w-full lg:w-3/5">
            <div className="text-red-600 text-base font-semibold tracking-widest uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
              About Butler Frelix
            </div>
            <h2
              className="text-3xl md:text-4xl font-black text-gray-900 leading-tight mb-6"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              BUILT FOR CHICAGO.
              <br />
              <span className="text-red-700">DESIGNED TO LAST A LIFETIME</span>
            </h2>

            <div className="bg-red-50 border-l-4 border-red-600 pl-5 pr-4 py-4 rounded-r-lg mb-6">
              <p className="text-gray-700 italic text-lg leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                &ldquo;We don&apos;t just build structures — we build things that last. Because at Butler Frelix, every build becomes a legacy.&rdquo;
              </p>
            </div>

            <p className="text-gray-600 text-base leading-relaxed mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              Butler Frelix Construction LLC has been a trusted name in Chicago construction for over <strong>11 years</strong> — handling everything from remodels and new construction to roofing, decks, and commercial buildouts.
            </p>

            <p className="text-gray-600 text-base leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
              Clients return because we treat every project like our own — showing up on time, pricing fairly, and never cutting corners. Our reputation is built on results, not advertising. When you hire Butler Frelix, you gain a partner who builds things worth being proud of.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {[
                { icon: 'ri-shield-check-line', label: 'Licensed & Insured' },
                { icon: 'ri-time-line', label: 'On-Time Delivery' },
                { icon: 'ri-money-dollar-circle-line', label: 'Fair Pricing' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded-lg">
                    <i className={`${item.icon} text-red-600 text-base`} />
                  </div>
                  <span className="text-gray-700 text-base font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
